import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';
import './RDDatePicker.scss';

const RDDatePicker = ({
  onDateSelect,
  allowClear,
  disabled,
  disabledDate,
  datePickerStyle,
  format,
  value,
  defaultValue,
  showTime,
  showToday,
  picker,
  disabledTime,
  onOk,
}) => (
  <DatePicker
    onChange={onDateSelect}
    allowClear={allowClear}
    disabled={disabled}
    style={datePickerStyle}
    format={format}
    disabledDate={disabledDate}
    disabledTime={disabledTime}
    value={value}
    defaultValue={defaultValue}
    showTime={showTime}
    showToday={showToday}
    picker={picker}
    onOk={onOk}
  />
);

RDDatePicker.defaultProps = {
  allowClear: true,
  disabled: false,
  defaultValue: moment(),
  value: moment(),
  datePickerStyle: {},
  format: 'L',
  disabledDate: () => {},
  disabledTime: () => {},
  onDateSelect: () => {},
  showTime: false,
  showToday: true,
  picker: 'date',
  onOk: () => {},
};

RDDatePicker.propTypes = {
  /** Callback function that is triggered when the selected time is changing */
  onDateSelect: PropTypes.func,
  /** Whether to show clear button */
  allowClear: PropTypes.bool,
  /** Determine whether the DatePicker is disabled */
  disabled: PropTypes.bool,
  /** The default date */
  defaultValue: PropTypes.shape({}),
  /** To customize the style of the input box */
  datePickerStyle: PropTypes.shape({}),
  /** To set the date format */
  format: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** Specify the date that cannot be selected */
  disabledDate: PropTypes.func,
  /** To specify the time that cannot be selected */
  disabledTime: PropTypes.func,
  /** The selected date */
  value: PropTypes.shape({}),
  /** To provide an additional time selection */
  showTime: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  /** Whether to show Today button */
  showToday: PropTypes.bool,
  /** Set picker type */
  picker: PropTypes.oneOf(['date', 'week', 'month', 'quarter', 'year']),
  /** Callback when click ok button */
  onOk: PropTypes.func,
};

export default RDDatePicker;
